// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_eu-0";